import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Tooltip from 'flarum/common/components/Tooltip';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import humanTime from 'flarum/common/helpers/humanTime';
import fullTime from 'flarum/common/helpers/fullTime';
import Link from 'flarum/common/components/Link';
import getProfileMessageComposer from './ProfileMessageComposer';
import ReportMessageModal from './ReportMessageModal';
export default class ProfileMessagesUserPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.moreResults = false;
    this.messages = [];

    // Expanded replies
    this.expandedReplies = {};
    this.repliesData = {};
    this.repliesLoading = {};
    this.loadUser(m.route.param('username'));
  }
  show(user) {
    super.show(user);

    // If profile messages are blocked, redirect to default posts view
    const actor = app.session.user;
    if (user.attribute('blockProfileMessages') && (!actor || actor.id() !== user.id())) {
      m.route.set(app.route('user', {
        username: user.slug()
      }));
      return;
    }
    this.refresh();
  }
  content() {
    return m("div", {
      className: "ProfileMessagesUserPage"
    }, this.postMessageButton(), this.loading ? m(LoadingIndicator, null) : this.messages.length === 0 ? m("div", {
      className: "ProfileMessages-empty"
    }, m("p", null, app.translator.trans('ralkage-profile-messages.forum.user.messages_empty_text'))) : m("div", {
      className: "ProfileMessages-list"
    }, this.messages.map(msg => this.messageItem(msg)), this.moreResults && m("div", {
      className: "ProfileMessages-loadMore"
    }, m(Button, {
      className: "Button",
      onclick: () => this.loadMore()
    }, app.translator.trans('ralkage-profile-messages.forum.user.messages_load_more_button')))));
  }
  postMessageButton() {
    const actor = app.session.user;
    if (!actor || !actor.attribute('canPostProfileMessages')) return '';
    const user = this.user;
    if (user && user.attribute('blockProfileMessages') && actor.id() !== user.id()) return '';
    return m("div", {
      className: "ProfileMessages-compose",
      style: "margin-bottom: 20px;"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-comment-dots",
      onclick: () => this.openComposer()
    }, app.translator.trans('ralkage-profile-messages.forum.composer.submit_button')));
  }
  async openComposer(parentId) {
    const component = await getProfileMessageComposer();
    const user = this.user;
    app.composer.load(component, {
      user,
      parentId: parentId || null,
      onsubmit: msg => {
        if (parentId) {
          // Add reply
          if (this.repliesData[parentId]) {
            this.repliesData[parentId].push(msg);
          }
          const parent = this.messages.find(m => m.id() === String(parentId));
          if (parent) {
            parent.pushAttributes({
              replyCount: (parent.replyCount() || 0) + 1
            });
          }
          this.expandedReplies[parentId] = true;
          if (!this.repliesData[parentId]) {
            this.loadReplies(parentId);
          }
        } else {
          // Add top-level message
          this.messages.unshift(msg);
        }
        m.redraw();
      }
    });
    app.composer.show();
  }
  messageItem(msg) {
    const author = msg.author();
    const replyCount = msg.replyCount();
    const msgId = msg.id();
    const isExpanded = this.expandedReplies[msgId];
    return m("div", {
      className: "ProfileMessage ProfileMessage--toplevel",
      key: msgId
    }, m("div", {
      className: "ProfileMessage-main"
    }, m("div", {
      className: "ProfileMessage-avatar"
    }, author ? m(Link, {
      href: app.route.user(author)
    }, m(Avatar, {
      user: author
    })) : m(Avatar, {
      user: null
    })), m("div", {
      className: "ProfileMessage-body"
    }, m("div", {
      className: "ProfileMessage-header"
    }, m("span", {
      className: "ProfileMessage-author"
    }, author ? m(Link, {
      href: app.route.user(author)
    }, username(author)) : '[deleted]'), this.messageMeta(msg), m("span", {
      className: "ProfileMessage-actions"
    }, this.messageActions(msg))), m("div", {
      className: "ProfileMessage-content"
    }, m.trust(msg.contentHtml())), msg.reportCount() > 0 && m("div", {
      className: "ProfileMessage-reportBadge"
    }, m("i", {
      className: "fas fa-flag"
    }), " ", msg.reportCount(), " ", msg.reportCount() === 1 ? 'report' : 'reports'), replyCount > 0 && m(Button, {
      className: "Button Button--link ProfileMessage-toggleReplies",
      onclick: () => this.toggleReplies(msgId)
    }, isExpanded ? app.translator.trans('ralkage-profile-messages.forum.message.hide_replies') : app.translator.trans('ralkage-profile-messages.forum.message.show_replies', {
      count: replyCount
    })))), isExpanded && m("div", {
      className: "ProfileMessage-replies"
    }, this.repliesLoading[msgId] ? m(LoadingIndicator, null) : (this.repliesData[msgId] || []).map(reply => this.replyItem(reply))));
  }
  replyItem(reply) {
    const author = reply.author();
    return m("div", {
      className: "ProfileMessage ProfileMessage--reply",
      key: reply.id()
    }, m("div", {
      className: "ProfileMessage-avatar ProfileMessage-avatar--small"
    }, author ? m(Link, {
      href: app.route.user(author)
    }, m(Avatar, {
      user: author
    })) : m(Avatar, {
      user: null
    })), m("div", {
      className: "ProfileMessage-body"
    }, m("div", {
      className: "ProfileMessage-header"
    }, m("span", {
      className: "ProfileMessage-author"
    }, author ? m(Link, {
      href: app.route.user(author)
    }, username(author)) : '[deleted]'), this.messageMeta(reply), m("span", {
      className: "ProfileMessage-actions"
    }, this.messageActions(reply, true))), m("div", {
      className: "ProfileMessage-content"
    }, m.trust(reply.contentHtml()))));
  }

  // --- Actions ---

  messageActions(msg, isReply) {
    return [!isReply && msg.canReply() && m(Tooltip, {
      text: app.translator.trans('ralkage-profile-messages.forum.message.reply_button')
    }, m(Button, {
      className: "Button Button--link ProfileMessage-action",
      icon: "fas fa-reply",
      onclick: () => this.openComposer(msg.id())
    })), msg.canEdit() && m(Tooltip, {
      text: app.translator.trans('ralkage-profile-messages.forum.message.edit_button')
    }, m(Button, {
      className: "Button Button--link ProfileMessage-action",
      icon: "fas fa-pencil-alt",
      onclick: () => this.editMessage(msg)
    })), msg.canReport() && m(Tooltip, {
      text: app.translator.trans('ralkage-profile-messages.forum.message.report_button')
    }, m(Button, {
      className: "Button Button--link ProfileMessage-action",
      icon: "fas fa-flag",
      onclick: () => this.reportMessage(msg)
    })), msg.canDelete() && m(Tooltip, {
      text: app.translator.trans('ralkage-profile-messages.forum.message.delete_button')
    }, m(Button, {
      className: "Button Button--link ProfileMessage-action ProfileMessage-action--danger",
      icon: "fas fa-trash",
      onclick: () => isReply ? this.deleteReply(msg) : this.deleteMessage(msg)
    }))].filter(Boolean);
  }
  messageMeta(msg) {
    const permalink = `${app.forum.attribute('baseUrl')}/profile-message/${msg.id()}`;
    const touch = 'ontouchstart' in document.documentElement;
    return m("div", {
      className: "Dropdown ProfileMessage-meta"
    }, m("a", {
      className: "Dropdown-toggle ProfileMessage-time",
      "data-toggle": "dropdown",
      onclick: e => {
        setTimeout(() => {
          const el = e.target.closest('.Dropdown').querySelector('.ProfileMessage-permalink');
          if (el && el.select) el.select();
        });
        e.redraw = false;
      }
    }, humanTime(msg.createdAt())), m("div", {
      className: "Dropdown-menu dropdown-menu"
    }, m("span", {
      className: "ProfileMessage-fullTime"
    }, fullTime(msg.createdAt())), touch ? m("a", {
      className: "Button ProfileMessage-permalink",
      href: permalink
    }, permalink) : m("input", {
      className: "FormControl ProfileMessage-permalink",
      value: permalink,
      onclick: e => e.stopPropagation()
    })));
  }
  async editMessage(msg) {
    app.composer.load(await getProfileMessageComposer(), {
      user: this.user,
      editMessage: msg,
      onsubmit: updated => {
        // The message will be updated in the store automatically
        m.redraw();
      }
    });
    app.composer.show();
  }
  reportMessage(msg) {
    app.modal.show(ReportMessageModal, {
      message: msg
    });
  }

  // --- Data ---

  refresh() {
    this.loading = true;
    this.messages = [];
    m.redraw();
    this.loadResults(0).then(() => {
      this.loading = false;
      m.redraw();
    });
  }
  loadResults(offset) {
    return app.store.find('profile-messages', {
      filter: {
        user: this.user.id()
      },
      page: {
        offset,
        limit: 20
      },
      sort: '-createdAt'
    }).then(results => {
      this.messages.push(...results);
      this.moreResults = results.payload && results.payload.links && results.payload.links.next;
      return results;
    });
  }
  loadMore() {
    this.loadResults(this.messages.length).then(() => m.redraw());
  }
  toggleReplies(msgId) {
    if (this.expandedReplies[msgId]) {
      this.expandedReplies[msgId] = false;
    } else {
      this.expandedReplies[msgId] = true;
      if (!this.repliesData[msgId]) {
        this.loadReplies(msgId);
      }
    }
  }
  loadReplies(parentId) {
    this.repliesLoading[parentId] = true;
    m.redraw();
    app.store.find('profile-messages', {
      filter: {
        user: this.user.id(),
        parent: parentId
      },
      page: {
        limit: 50
      }
    }).then(results => {
      this.repliesData[parentId] = results;
      this.repliesLoading[parentId] = false;
      m.redraw();
    });
  }
  deleteMessage(msg) {
    if (!confirm(app.translator.trans('ralkage-profile-messages.forum.message.delete_confirm'))) return;
    msg.delete().then(() => {
      this.messages = this.messages.filter(m => m.id() !== msg.id());
      m.redraw();
    });
  }
  deleteReply(reply) {
    if (!confirm(app.translator.trans('ralkage-profile-messages.forum.message.delete_confirm'))) return;
    const parentId = reply.parentId();
    reply.delete().then(() => {
      if (this.repliesData[parentId]) {
        this.repliesData[parentId] = this.repliesData[parentId].filter(r => r.id() !== reply.id());
      }
      const parent = this.messages.find(m => m.id() === String(parentId));
      if (parent) {
        parent.pushAttributes({
          replyCount: Math.max(0, (parent.replyCount() || 0) - 1)
        });
      }
      m.redraw();
    });
  }
}
flarum.reg.add('ralkage-profile-messages', 'forum/components/ProfileMessagesUserPage', ProfileMessagesUserPage);